import {Tooltip, Typography} from '@mui/material'
import type {TypographyProps} from '@mui/material'
import type {FC, ReactElement} from 'react'
import {useEffect, useRef, useState} from 'react'

interface OverflowTypographyProps extends TypographyProps {
  children: string
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right'
}
const OverflowTypography: FC<OverflowTypographyProps> = ({
  children,
  tooltipPlacement = 'bottom',
  ...props
}): ReactElement => {
  const textRef = useRef<HTMLElement>(null)
  const [isOverflow, setIsOverflow] = useState(false)

  const checkOverflow = (): void => {
    const {current} = textRef
    if (!current) {
      return
    }
    setIsOverflow(current.scrollWidth > current.clientWidth)
  }

  useEffect(() => {
    checkOverflow()
    window.addEventListener('resize', checkOverflow)
    return () => {
      window.removeEventListener('resize', checkOverflow)
    }
  }, [children])

  return (
    <Tooltip
      title={isOverflow ? children : ''}
      placement={tooltipPlacement}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {offset: [0, 20]},
            },
          ],
        },
      }}
    >
      <Typography ref={textRef} data-testid="mbai-overflow-typography" {...props}>
        {children}
      </Typography>
    </Tooltip>
  )
}

export default OverflowTypography
